module.exports = __webpack_public_path__ + "img/arrow_3.fc8b277f.png";